export const TOPBAR = 'topbar';
export const LOGINPAGE = 'loginpage';
export const ISLIGHT = 'islight';
